export default __webpack_public_path__ + "static/media/proposal-white.1827aa9e.svg";